import { useEffect } from 'react';

const MaxMind = () => {
  const loadDeviceJs = () => {
    const element = document.createElement('script');
    element.src = 'https://device.maxmind.com/js/device.js';
    document.body.appendChild(element);
  };

  useEffect(() => {
    window.maxmind_user_id = process.env.MAXMIND_ACCOUNT_ID;
    window.addEventListener('load', loadDeviceJs, false);
    return () => window.removeEventListener('load', loadDeviceJs, false);
  }, []);

  return <></>;
};

export default MaxMind;
